<template>
  <SelectField
    v-bind="$attrs"
    v-model="state.value"
    :options="state.options"
  />
</template>

<script>
import SelectField from 'Web/Form/Fields/SelectField.vue';
import Http from '@/helpers/http';
import get from 'lodash/get';
import { onMounted, reactive, watchEffect } from 'vue';

export default {
  inheritAttrs: false,
  emits: [
    'update:modelValue',
  ],
  components: {
    SelectField,
  },
  props: {
    modelValue: null,
    query: {
      type: [String, Function],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: [String, Function],
      default: 'id',
    },
    text: {
      type: [String, Function],
      default: 'name',
    },
  },
  setup(props, { emit }) {
    const state = reactive({
      options: [],
      value: props.modelValue,
    });

    function getBy(object, predicate, defaultValue = null) {
      return typeof predicate === 'function'
        ? predicate(object) || defaultValue
        : get(object, predicate, defaultValue)
    }

    watchEffect(() => {
      const value = getBy(props.modelValue, props.value, props.modelValue);

      emit('update:modelValue', state.value = value);
    });

    watchEffect(() => {
      state.options = props.options.map(transform);
    });

    watchEffect(() => {
      emit('update:modelValue', state.value);
    });

    function fetch() {
      if (typeof props.query === 'function')
        return props.query();

      return Http.get(props.query);
    }

    function transform(option) {
      return {
        value: getBy(option, props.value),
        text: getBy(option, props.text),
      }
    }

    onMounted(async () => {
      if (!props.query)
        return;

      state.options = (await fetch()).map(transform);
    });

    return {
      state,
    }
  }
}
</script>
